import React, { ReactNode } from 'react'
import styles from './accountSection.module.scss'
import classNames from 'classnames'

interface Props {
  children: ReactNode
  title: string
  subtitle?: string
  classWrapper?: string
  classBoby?: string
}

const AccountSection = ({
  children,
  title,
  subtitle,
  classWrapper = '',
  classBoby = '',
}: Props) => {
  return (
    <div className={classNames(styles.accountSection, classWrapper)}>
      <section className={styles.topSection}>
        <h2 className={styles.mainHeading}>{title}</h2>
        {subtitle && <p>{subtitle}</p>}
      </section>
      <section className={classBoby}>{children}</section>
    </div>
  )
}

export default AccountSection
